<app-i18n-dictionary>
    <span [attr.transid]="searchableAttributes.decor.i18id" i18n="@@product-sorted-search_field-decor">Decor</span>
    <span [attr.transid]="searchableAttributes.productType.i18id" i18n="@@product-sorted-search_field-product-type">Shape</span>
    <span [attr.transid]="searchableAttributes.occasion.i18id"
          i18n="@@product-sorted-search_field-occasion">Occasion</span>
    <span [attr.transid]="searchableAttributes.purpose.i18id"
          i18n="@@product-sorted-search_field-purpose">Purpose</span>
    <span [attr.transid]="searchableAttributes.productCategory.i18id" i18n="@@product-sorted-search_field-category">Inspiration</span>
    <span [attr.transid]="searchableAttributes.color.i18id" i18n="@@product-sorted-search_field-color">Color</span>
    <span [attr.transid]="fieldAdvancedSearchTextId" i18n="@@product-sorted-search_field-advanced-search">Advanced Search</span>
    <span [attr.transid]="fieldSortTextId" i18n="@@product-sorted-search_field-sort">Sort</span>

    <span [attr.transid]="sortOptions[0].i18id" i18n="@@product-sorted-search_sort-by-article">By Article</span>
    <span [attr.transid]="sortOptions[1].i18id" i18n="@@product-sorted-search_sort-by-hi-price">Highest Price</span>
    <span [attr.transid]="sortOptions[2].i18id" i18n="@@product-sorted-search_sort-by-lo-price">Lowest Price</span>
    <span [attr.transid]="sortOptions[3].i18id" i18n="@@product-sorted-search_sort-by-new-in">New In</span>


</app-i18n-dictionary>

<div fxShow fxHide.lt-md>
    <ng-container *ngTemplateOutlet="desktopMenu">
    </ng-container>
</div>
<div fxHide fxShow.lt-md>
    <ng-container *ngTemplateOutlet="mobileMenu"></ng-container>
</div>

<ng-template #mobileMenu>
    <div class="search-form" fxLayoutAlign="center center">
        <button class="btn-primary main-btn" mat-button i18n="@@product-sorted-search_field-advanced-search"
                (click)="onOpenAdvancedSearch()">
            Advanced Search
        </button>
    </div>
</ng-template>

<ng-template #desktopMenu>
    <form class="search-form" [formGroup]="form">
        <input type="submit" style="display: none"/>

        <mat-form-field appearance="none" *ngFor="let field of multipleFieldSelections">
            <mat-select formControlName="{{field.formName}}" multiple (selectionChange)="submitSearch()"
                        (opened)="onSelectOpen()" [placeholder]="i18nDictionary.get(field.i18nId)"
                        panelClass="{{field.panelClass}}" disableOptionCentering
                        [ngClass]="{'multiple-selected': form.controls[field.formName].value.length > 0}"
                        class="search-select"
                        #matSelect>
                <mat-select-trigger>
                    <span class="example-additional-selection">{{i18nDictionary.get(field.i18nId)}}</span>
                </mat-select-trigger>
                <div class="select-buttons">
                    <button class="main-btn" (click)="resetSearchSelect(field.formName)">{{"Reset" | uppercase}}</button>
                    <button i18n="@@product-sorted-search_save-upper" class="main-btn"
                            (click)="saveSelect(matSelect)">{{"Save" | uppercase}}</button>
                </div>
                <div class="select-options">
                    <mat-option *ngFor="let attributeOption of field.attributeOptions" [value]="attributeOption">
                        {{attributeOption.label}}
                    </mat-option>
                </div>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="none">
            <mat-select [compareWith]="compare" formControlName="sort" (selectionChange)="submitSearch()"
                        (opened)="onSelectOpen()" disableRipple [placeholder]="i18nDictionary.get(fieldSortTextId)"
                        panelClass="sort-select" disableOptionCentering class="search-select" #sortSelect>
                <div class="select-buttons">
                    <button class="main-btn" (click)="resetSearchSelect('sort')">{{"Reset" | uppercase}}</button>
                    <button i18n="@@product-sorted-search_save-upper" class="main-btn"
                            (click)="saveSelect(sortSelect)">{{"Save" | uppercase}}</button>
                </div>
                <div class="select-options sorting-options">
                    <mat-option *ngFor="let attributeOption of sortOptions" [value]="attributeOption.value">
                        <div class="label">{{i18nDictionary.get(attributeOption.i18id)}}</div>
                        <div class="sorting-pseudo-checkbox"></div>
                    </mat-option>
                </div>
            </mat-select>
        </mat-form-field>

        <div class="reset">
            <button class="btn-primary main-btn" (click)="resetDropdowns()">Reset</button>
        </div>
    </form>
</ng-template>

<ng-template #mobileMenu></ng-template>
